// removed by extract-text-webpack-plugin
module.exports = {"tabsWrapper":"_2NWFU7LEdENC4nABAzZNK0","tabs":"gq_ZahEBGrFCorCFuRwcu","navTabs":"_2MvH8BqdVcM_YS2CMp2_Fl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StatefulTabs/NavTabs.scss
// module id = 1782
// module chunks = 0